/** @internal */
export const OP_STATE_PENDING = "Pending" as const

/** @internal */
export type OP_STATE_PENDING = typeof OP_STATE_PENDING

/** @internal */
export const OP_STATE_DONE = "Done" as const

/** @internal */
export type OP_STATE_DONE = typeof OP_STATE_DONE
